import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../report.service';
import { UtilService } from '../../../service/util.service';
import { IonicSelectableComponent } from 'ionic-selectable';
import { Storage } from '@ionic/storage';
import { UserProfile } from '../../../models/user-profile.model';
import { AlertController, ModalController, ToastController } from '@ionic/angular';
import * as XLSX from 'xlsx';
import { ReportStockPointComponent } from '../../../component/report-stock-point/report-stock-point.component';
import { ReportCashierCounterListComponent } from '../../../component/report-cashier-counter-list/report-cashier-counter-list.component';

@Component({
  selector: 'app-report-point-mutation',
  templateUrl: './report-point-mutation.page.html',
  styleUrls: ['./report-point-mutation.page.scss'],
})
export class ReportPointMutationPage implements OnInit {

  @Input() counterList: any[];

  @ViewChild('counterComponent', { static: false }) counterComponent: IonicSelectableComponent

  selectedMonth: string;

  dataReport = [];
  counters:any[]=[];
  counterId:any ='';
  counterData:any=[];
  counterByLogin : any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  selectedCounters: any[]=[];
  
  years: number[] = [];
  selectedYear: number | null = null;
  showBtnCounterList:boolean=false;
  constructor(
    private storage: Storage,
    private reportService: ReportService,
    private utilService:UtilService,
    private alertController:AlertController,
    private modalController:ModalController,
    private toastCtrl:ToastController
  ) {
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.years.push(currentYear - i);
    }
   }

  ngOnInit() {  
    Promise.all([
        this.storage.get('user_token'),
        this.storage.get('user_profile')
    ])
    .then(([token, profile]) => {
      if(token) {
        this.token = token;
        this.selectedCounters = [];
        this.utilService.loadingPresent('Harap tunggu...')
        .then(() => {
          this.years=[];
          const currentYear = new Date().getFullYear();
          for (let year = currentYear; year >= 2025; year--) {
            this.years.push(year);
          }
          this.userProfile = new UserProfile(profile);
          this.counterByLogin = this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list;
          this.utilService.loadingDismiss();
          let options = { 
            "token": this.token,
            "branch_id": '',
            "counter_id": this.counterByLogin 
          };
          this.reportService.getCounterByBranchId(options).subscribe((response) => {
            this.utilService.loadingDismiss();
            this.counterData = [];
            this.counterData = response.results;
            let checkedCounter =this.counterId !=='' ? this.counterId :this.counterByLogin ;
            let counterIdSplit = checkedCounter !== '' ? String(checkedCounter).split(',') : [];
            let idCounter = 'n,';
            this.counterData.push({
              "id":'n',
              "counter_code":"",
              "counter_name":"Tidak Ada Counter"
            })
            this.selectedCounters.push({
              "id":'n',
              "counter_code":"",
              "counter_name":"Tidak Ada Counter"
            });
            for(let i= 0; i < checkedCounter.length; i++) {
              let selectedCounter: any = this.counterData.find(x => x.id ==  counterIdSplit[i]);
              if(selectedCounter){
                let idx =this.counterData.indexOf(selectedCounter);
                this.selectedCounters.push(this.counterData[idx]);          
                idCounter += this.counterData[idx]['id']+',';
              }
            }
            idCounter = idCounter.replace(/(^,)|(,$)/g, "");
            this.counterId = idCounter;
            this.selectedYear = new Date().getFullYear();
            this.selectedMonth = new Date().getMonth().toString();
            this.setSelectedMonth(new Date().getMonth()+1);
            this.getData();
          }, () => {});
        })
      }    
    })
  }
  ionViewDidEnter(){}

  getData(){
    if (!this.selectedMonth || !this.selectedYear || !this.counterId) {
      this.presentAlert('Mohon isi semua field: Bulan, Tahun, dan Counter  terlebih dahulu!');
      return;
    }
    this.dataReport = [];
    let options={
      "counter_id":this.counterId,
      "month":this.selectedMonth,
      "year": this.selectedYear
    }
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
    this.reportService.reportPointMutation(options).subscribe((response) => {
      this.utilService.loadingDismiss();
      if (response.status.code == 200) {
        const monthPadded = this.selectedMonth.toString().padStart(2, '0');
        const earlyKey = `early_${monthPadded}`;
        const inKey = `in_${monthPadded}`;
        const outKey = `out_${monthPadded}`;
        const endKey = `end_${monthPadded}`;
        this.dataReport = response.results.filter((item: any) => {
          return (
            (Number(item[earlyKey]) || 0) !== 0 ||
            (Number(item[inKey]) || 0) !== 0 ||
            (Number(item[outKey]) || 0) !== 0 ||
            (Number(item[endKey]) || 0) !== 0
          );
        });
        
        let loopCounter = 0;
        if(this.selectedCounters.length >5) {
          loopCounter = 5;
          this.showBtnCounterList = true;
        } else {
          loopCounter = this.selectedCounters.length;
          this.showBtnCounterList = false;
        }
      }
    }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal mendapatkan data Report!' }).then(t => t.present());
      });
    });
  }
  async presentAlert(message: string) {
    const alert = await this.alertController.create({
      message: message,
      buttons: ['OK'],
    });
    await alert.present();
  }

  applyFilter() {
    this.getData();
  }

  toggleCounterItems() {
    this.counterComponent.toggleItems(
      this.counterComponent.itemsToConfirm.length ? false : true
    );
  }

  confirmCounter() {
    this.counterComponent.confirm();
    this.counterComponent.close();  
    this.counterList = [];
    this.counterList = this.counterComponent.value;
    let idCounter ='';
    for(let i=0;i<this.counterList.length;i++){
      idCounter += this.counterList[i].id+',';
    }
    idCounter = idCounter.replace(/(^,)|(,$)/g, "");
    this.counterId = idCounter;
  }

  setSelectedMonth(month: number) {
    this.selectedMonth = month < 10 ? '0' + month : month.toString();
  }
  cleanValue(val: any): number | string {
    const num = Number(val);
    if (isNaN(num)) return val;
    return num === 0 ? 0 : num;
  }

  exportToExcel() {
    let dataForExport = [];
    if(this.dataReport.length>0){
      for (let i = 0; i < this.dataReport.length; i++) {
        const item = this.dataReport[i];
        const m = this.selectedMonth;
        dataForExport.push({
          No: i + 1,
          "Counter ID":  (item.counter_id == 0 || item.counter_id == null) ? '' : item.counter_id,
          "Counter Name": item.counter_name,
          "Customer ID": item.customer_id,
          "Customer Name": item.customer_name,
          "No HP": item.phone,
          "Gender": item.gender,
          "Tanggal Lahir": item.birth_date,
          "Tier": item.tier_name,
          "Provinsi": item.province_name,
          "Poin Awal": item['early_' + m],
          "Value Poin Awal": this.cleanValue(item['early_value_' + m]),
          "Poin Masuk": item['in_' + m],
          "Value Poin Masuk": this.cleanValue(item['in_value_' + m]),
          "Poin Keluar": item['out_' + m],
          "Value Poin Keluar": this.cleanValue(item['out_value_' + m]),
          "Poin Akhir": item['end_' + m],
          "Value Poin Akhir": this.cleanValue(item['end_value_' + m]),
        });
      }

    }
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataForExport);
    
    const objectMaxLength: number[] = [];
    dataForExport.forEach(row => {
      Object.values(row).forEach((value, colIndex) => {
        const length = String(value).length;
        objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, length);
      });
    });
    Object.keys(dataForExport[0]).forEach((header, colIndex) => {
      objectMaxLength[colIndex] = Math.max(objectMaxLength[colIndex] || 0, header.length);
    });
    ws['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 }));
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'Laporan Poin Mutasi.xlsx');
  }
  async showCounterList() {
    const modal = await this.modalController.create({
      component: ReportCashierCounterListComponent,
      componentProps: {
        counterList: this.selectedCounters
      },
      backdropDismiss: false
    });
    return await modal.present();
  }
  async openMutationStockDetail(customerId: any,customerName:any,earlyStock:any,endStock:any,type:any) {
    const modal = await this.modalController.create({
      component: ReportStockPointComponent,
      componentProps: {
        'customerId': customerId,
        'customerName':customerName,
        'month':this.selectedMonth,
        'year':this.selectedYear,
        'earlyStock': earlyStock,
        'endStock': endStock,
        'type' : type
      },
      backdropDismiss: false
    });
    modal.onDidDismiss().then(() => {
    });
    return await modal.present();
  }
}
